import { imgUrl } from "../../utils/helper";

export const aboutData = {
  title: "About US",
  subtitle:
    "We, at Tenacious, apply neuromarketing and behavioral science to design, digitize and grow your business.",
  image1: imgUrl + "banner.png",
  image2: imgUrl + "banner-2.png",
  whotitle: "Who we are?",
  whosubtitle:
    "We are a team of Artists, Innovators & Strategists who left their ordinary life to invent and reinvent the common. Our Passion for technologies changes problems into opportunities. Our heart is full of creative juice that shapes ideas, Our mind is on a quest to transform the ordinary into the extraordinary. This is our code that energizes deep-rooted human desires and makes people pursue their dreams. We took an oath to stick to the Code and call ourselves Code Theorem.",
  whattitle: " What we do?",
  whatsubtitle:
    " We prepare delicious dishes from a blend of design and technologies  with extra cheese of greatness. With proven experience in pushing start-ups on the growth track by identifying their needs and delivering the growth package. We manifest what you aspire. We are Code Theorem Ahead of time, behind the budget line, Forward-thinking, Creating Seamless Digital Life, That’s Our routine. Every idea you bring to the table is nurtured and yield to conquer. With us, you don’t invest in design and development, you invest in brand building and digital growth.",
  Vision:
    "To be the world's best and most trusted human experience design company",
  Mission: "To enhance and elevate human interaction",
  Values: "To pursue excellence through dedicated teamwork",
  aboutUS: [
    {
      title: "Vision",
      subtitle:
        "To be the world's best and most trusted human experience design company",
    },
    {
      title: "Mission",
      subtitle: "To enhance and elevate human interaction",
    },
    {
      title: "Values",
      subtitle: "To pursue excellence through dedicated teamwork",
    },
  ],
};
